import { logger } from '@luna/logger';
import { differenceInSeconds } from '@luna/date';

let loadingStartDate: Date | undefined;
let loadingEndDate: Date | undefined;

export function startLoadingTimeTracking(): void {
    if (loadingStartDate) {
        logger.error(
            'startLoadingTimeTracking has been already called, has to be called just once',
        );
    } else {
        loadingStartDate = new Date();
    }
}

export function stopLoadingTimeTracking(): void {
    if (loadingEndDate) {
        logger.error('stopLoadingTimeTracking has been already called, has to be called just once');
    } else {
        loadingEndDate = new Date();
    }
}

export function getLoadingTime(): number | null {
    if (!loadingStartDate) {
        logger.error('startLoadingTimeTracking was not called');
        return null;
    }

    if (!loadingEndDate) {
        logger.error('stopLoadingTimeTracking was not called');
        return null;
    }

    return differenceInSeconds(loadingEndDate, loadingStartDate);
}
